// @ts-nocheck
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'submitButton', 'withdrawalPlatform'];
  static values = { platform: String };

  onChangeAgreement(event) {
    const isChecked = event.target.checked;
    this.submitButtonTarget.disabled = !isChecked;
    if (isChecked) {
      this.submitButtonTarget.classList.remove('btn-disabled');
    } else {
      this.submitButtonTarget.classList.add('btn-disabled');
    }
  }

  onChangeWithdrawPlatform() {
    const checkboxes = this.element.querySelectorAll("input.js-platform[type='checkbox']");
    const checkedValues = Array.from(checkboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);

    let platformValue;
    if (checkedValues.length === 2) {
      platformValue = 'both';
    } else if (checkedValues.length === 1) {
      platformValue = checkedValues[0];
    } else {
      platformValue = '';
    }

    this.withdrawalPlatformTarget.value = platformValue;
  }

  onSubmit(event) {
    const btnEl = event.currentTarget || this.submitButtonTarget;
    const isPlatformAgent = JSON.parse(btnEl?.dataset?.isPlatformAgent || 'false');
    const isPlatformDirect = JSON.parse(btnEl?.dataset?.isPlatformDirect || 'false');
    const isWithdrawBothPlatform = this.withdrawalPlatformTarget.value === 'both';
    event.preventDefault();
    // start loading UI
    try {
      const btn = this.submitButtonTarget;
      const label = btn.querySelector('.js-btn-label');
      const spinner = btn.querySelector('.js-btn-spinner');
      btn.classList.add('pe-none', 'af-btn-loading');
      btn.setAttribute('aria-disabled', 'true');
      if (label) label.classList.add('opacity-0');
      if (spinner) spinner.classList.remove('d-none');
    } catch (e) {}
    Rails.ajax({
      url: this.formTarget.action,
      type: 'POST',
      data: new FormData(this.formTarget),
      dataType: 'json',
      success: response => {
        this.formTarget.innerHTML = response.entries;
        if (response.status === 200) {
          if (isPlatformAgent || isPlatformDirect || isWithdrawBothPlatform) {
            this._toggleModal('withdrawalPlatformModal');
          } else {
            this._toggleModal('changePlatformModal');
          }
        }
      },
      error: () => {
        window.location.reload();
      },
      complete: () => {
        try {
          const btn = this.submitButtonTarget;
          const label = btn.querySelector('.js-btn-label');
          const spinner = btn.querySelector('.js-btn-spinner');
          btn.classList.remove('pe-none', 'af-btn-loading');
          btn.removeAttribute('aria-disabled');
          if (label) label.classList.remove('opacity-0');
          if (spinner) spinner.classList.add('d-none');
        } catch (e) {}
      },
    });
  }

  _toggleModal(id) {
    const modalElement = document.getElementById(id);
    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';

    if (modalElement.classList.contains('show')) {
      modalElement.classList.remove('show');
      document.body.classList.remove('modal-open');
      modalElement.style.display = 'none';
      document.querySelectorAll('.modal-backdrop.fade.show').forEach(el => el.remove());
    } else {
      modalElement.classList.add('show');
      document.body.classList.add('modal-open');
      modalElement.style.display = 'block';
      document.body.appendChild(backdrop);
    }
  }

  onCloseModal(event) {
    this._toggleModal(`${event.target.dataset.modalId}`);
  }
}
